module.exports = __webpack_public_path__ + "img/Group 3338.68a0f9fd.svg";